'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _semanticUiReact = require('semantic-ui-react');

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _textHighlighter = require('../text-highlighter');

var _textHighlighter2 = _interopRequireDefault(_textHighlighter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cf = function cf(num) {
  return (0, _numeral2.default)(num).format('0,0');
};
var MAX_UNFILTERED_RECORDS = 7;
var ROLLUP_FACTOR = 4;

var emptyArray = [];

var highlightStyle = {
  backgroundColor: '#FDB02B'
};

var labelStyle = {
  marginTop: 5
};

var captionStyle = {
  maxHeight: 250,
  display: 'block',
  overflowY: 'scroll'
};

var InstagramStory = function (_React$Component) {
  (0, _inherits3.default)(InstagramStory, _React$Component);

  function InstagramStory(props) {
    (0, _classCallCheck3.default)(this, InstagramStory);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InstagramStory.__proto__ || (0, _getPrototypeOf2.default)(InstagramStory)).call(this, props));

    _this.getFilteredStoryData = function () {
      var _this$props = _this.props,
          storyData = _this$props.storyData,
          publishedDate = _this$props.publishedDate;

      var safeStoryData = storyData || [];
      return !_this.shouldFilter() ? safeStoryData : _lodash2.default.filter(safeStoryData, function (record, i) {
        if (i === storyData.length - 1) return true;
        var storyAge = (0, _moment2.default)(record.createdDate).diff((0, _moment2.default)(publishedDate), 'hours');
        return storyAge % ROLLUP_FACTOR === 0;
      });
    };

    _this.shouldFilter = function () {
      if (_this.state.isExpanded) return false;
      var storyData = _this.props.storyData;

      return storyData && storyData.length > MAX_UNFILTERED_RECORDS;
    };

    _this.toggleExpand = function () {
      var isExpanded = _this.state.isExpanded;

      _this.setState({
        isExpanded: !isExpanded
      });
    };

    _this.handleChange = function (e, _ref) {
      var _this$setState;

      var name = _ref.name,
          value = _ref.value,
          storyId = _ref.storyId;

      console.log('hello');
      console.log(name, value, storyId);
      _this.setState((_this$setState = {}, (0, _defineProperty3.default)(_this$setState, name, value), (0, _defineProperty3.default)(_this$setState, 'storyId', storyId), (0, _defineProperty3.default)(_this$setState, 'addToCampaignConfirmOpen', true), _this$setState));
    };

    _this.handleAddConfirm = function () {
      var onCampaignSelected = _this.props.onCampaignSelected;
      var _this$state = _this.state,
          storyId = _this$state.storyId,
          selectedCampaignId = _this$state.selectedCampaignId;

      _this.setState({
        addToCampaignConfirmOpen: false
      }, function () {
        return onCampaignSelected({ storyId: storyId, selectedCampaignId: selectedCampaignId });
      });
    };

    _this.handleAddCancel = function () {
      return _this.setState({
        storyId: null,
        selectedCampaignId: null,
        addToCampaignConfirmOpen: false
      });
    };

    _this.state = {
      isExpanded: _lodash2.default.get(props, 'expanded', false),
      selectedCampaignId: null,
      addToCampaignConfirmOpen: false
    };
    return _this;
  }

  (0, _createClass3.default)(InstagramStory, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          assetType = _props.assetType,
          caption = _props.caption,
          storyData = _props.storyData,
          publishedDate = _props.publishedDate,
          savedThumbnailUrl = _props.savedThumbnailUrl,
          savedMediaUrl = _props.savedMediaUrl,
          username = _props.username,
          status = _props.status,
          assetURL = _props.assetURL,
          campaignList = _props.campaignList,
          campaign = _props.campaign,
          fluid = _props.fluid,
          hashtags = _props.hashtags,
          mentions = _props.mentions,
          campaignHashtags = _props.campaignHashtags,
          shouldHighlight = _props.shouldHighlight,
          handlesCampaignAdd = _props.handlesCampaignAdd;
      var _state = this.state,
          isExpanded = _state.isExpanded,
          selectedCampaignId = _state.selectedCampaignId;


      var storyMentions = _lodash2.default.isArray(mentions) ? mentions : _lodash2.default.split(mentions, ',');
      var storyHashtags = _lodash2.default.isArray(hashtags) ? hashtags : _lodash2.default.split(hashtags, ',');

      var isVideo = assetType === 'VIDEO';
      var isLive = status === 'LIVE';
      var imageUrl = savedThumbnailUrl || savedMediaUrl;

      var storyImage = imageUrl ? _react2.default.createElement(_semanticUiReact.Image, { src: imageUrl, size: 'large' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: isVideo ? 'film' : 'image', size: 'massive', color: 'pink' });

      var StoryVideo = function StoryVideo() {
        return _react2.default.createElement(
          'div',
          null,
          _lodash2.default.isNil(savedMediaUrl) && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_semanticUiReact.Image, { src: imageUrl, size: 'large' }),
            _react2.default.createElement(
              'span',
              null,
              'Video not available'
            )
          ),
          savedMediaUrl && _react2.default.createElement(_reactPlayer2.default, { url: savedMediaUrl, width: '100%', height: '100%', controls: true })
        );
      };

      var storyContent = isVideo ? _react2.default.createElement(StoryVideo, null) : storyImage;

      var statusMessage = _react2.default.createElement(
        _semanticUiReact.Message,
        { color: isLive ? 'green' : 'grey' },
        _react2.default.createElement(_semanticUiReact.Icon, { name: isLive ? 'flag outline' : 'flag checkered' }),
        'Posted on ',
        (0, _moment2.default)(publishedDate).format('dddd, MMMM Do YYYY, h:mm:ss a'),
        '\xA0---\xA0',
        _react2.default.createElement(
          'strong',
          null,
          '(',
          status,
          ')'
        )
      );

      var statusMessageLink = _react2.default.createElement(
        'a',
        { href: assetURL },
        statusMessage
      );

      var mutedStyle = { color: 'rgba(0,0,0,.4)' };
      var captionElement = caption ? _react2.default.createElement(_textHighlighter2.default, {
        words: shouldHighlight ? campaignHashtags : emptyArray,
        text: caption,
        style: captionStyle
      }) : _react2.default.createElement(
        'div',
        { style: mutedStyle },
        _react2.default.createElement(
          _semanticUiReact.Icon.Group,
          { size: 'large' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'chat' }),
          _react2.default.createElement(_semanticUiReact.Icon, { corner: true, name: 'delete' })
        ),
        _react2.default.createElement('br', null),
        'No Caption'
      );

      var leftColumn = isExpanded ? _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 6 },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          storyContent
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: isVideo ? 'film' : 'image', size: 'small', color: 'pink' }),
          assetType,
          _react2.default.createElement(_semanticUiReact.Divider, null),
          captionElement,
          _lodash2.default.map(storyMentions, function (mention) {
            return _react2.default.createElement(_semanticUiReact.Label, { style: labelStyle, basic: true, color: 'pink', content: _lodash2.default.toLower(mention) });
          }),
          _lodash2.default.map(storyHashtags, function (hashtag) {
            return _react2.default.createElement(_semanticUiReact.Label, { style: labelStyle, basic: true, color: 'green', content: _lodash2.default.toLower(hashtag) });
          })
        )
      ) : _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 6 },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8 },
              storyContent
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8 },
              _react2.default.createElement(_semanticUiReact.Icon, { name: isVideo ? 'film' : 'image', size: 'small', color: 'pink' }),
              assetType,
              _react2.default.createElement(_semanticUiReact.Divider, null),
              captionElement,
              _lodash2.default.map(storyMentions, function (mention) {
                return _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'pink', content: _lodash2.default.toLower(mention) });
              }),
              _lodash2.default.map(storyHashtags, function (hashtag) {
                return _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'green', content: _lodash2.default.toLower(hashtag) });
              })
            )
          )
        )
      );

      var selectedCampaign = _lodash2.default.find(campaignList, { key: selectedCampaignId }) || { text: 'no campaign' };

      return _react2.default.createElement(
        _semanticUiReact.Card,
        { color: 'pink', fluid: fluid },
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { columns: 3 },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: handlesCampaignAdd ? 10 : 15 },
                _react2.default.createElement(
                  'h3',
                  null,
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
                  username
                )
              ),
              handlesCampaignAdd && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 5 },
                campaign ? _react2.default.createElement(_semanticUiReact.Button, { fluid: true, content: campaign.name, color: 'pink', inverted: true, disabled: true }) : _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    button: true,
                    className: 'icon',
                    floating: true,
                    labeled: true,
                    icon: 'add',
                    options: campaignList,
                    search: true,
                    fluid: true,
                    name: 'selectedCampaignId',
                    text: 'Add to Campaign',
                    storyId: id,
                    value: selectedCampaignId,
                    onChange: this.handleChange
                  }),
                  _react2.default.createElement(_semanticUiReact.Confirm, {
                    header: 'Add to Campaign?',
                    content: 'Add story to ' + selectedCampaign.text,
                    open: this.state.addToCampaignConfirmOpen,
                    onCancel: this.handleAddCancel,
                    onConfirm: this.handleAddConfirm,
                    size: 'small'
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 1 },
                _react2.default.createElement(_semanticUiReact.Popup, {
                  position: 'right center',
                  trigger: _react2.default.createElement(
                    _semanticUiReact.Button,
                    { circular: true, color: 'pink', inverted: true, onClick: this.toggleExpand, icon: true },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: this.state.isExpanded ? 'angle up' : 'angle down' })
                  ), content: this.state.isExpanded ? 'See less' : 'See more'
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { textAlign: 'center', divided: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              leftColumn,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 10 },
                _react2.default.createElement(
                  _semanticUiReact.Table,
                  { basic: 'very', compact: 'very', textAlign: 'center', columns: 'seven' },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Header,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.HeaderCell,
                        null,
                        'time'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.HeaderCell,
                        null,
                        'reach'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.HeaderCell,
                        null,
                        'impressions'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.HeaderCell,
                        null,
                        'taps forward'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.HeaderCell,
                        null,
                        'taps back'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.HeaderCell,
                        null,
                        'exits'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.HeaderCell,
                        null,
                        'story age (hours)'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Body,
                    null,
                    _lodash2.default.map(this.getFilteredStoryData(), function (record) {
                      var storyAge = (0, _moment2.default)(record.createdDate).diff((0, _moment2.default)(publishedDate), 'hours');
                      return _react2.default.createElement(
                        _semanticUiReact.Table.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Table.Cell,
                          null,
                          (0, _moment2.default)(record.createdDate).format('ddd H:mm')
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Table.Cell,
                          null,
                          cf(record.reach)
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Table.Cell,
                          null,
                          cf(record.impressions)
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Table.Cell,
                          null,
                          cf(record.taps_forward)
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Table.Cell,
                          null,
                          cf(record.taps_back)
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Table.Cell,
                          null,
                          cf(record.exits)
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Table.Cell,
                          null,
                          storyAge
                        )
                      );
                    })
                  )
                ),
                isLive ? statusMessageLink : statusMessage
              )
            )
          )
        )
      );
    }
  }]);
  return InstagramStory;
}(_react2.default.Component);

InstagramStory.propTypes = {
  shouldHighlight: _propTypes2.default.bool,
  campaignHashtags: _propTypes2.default.array,
  handlesCampaignAdd: _propTypes2.default.bool,
  expanded: _propTypes2.default.bool
};

InstagramStory.defaultProps = {
  shouldHighlight: false,
  handlesCampaignAdd: true,
  campaignHashtags: [],
  expanded: false
};

exports.default = InstagramStory;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/instagram-story/index.js
 ** module id = 601
 ** module chunks = 0
 **/